class Builder {
     /**
      * Takes an array and build it's into a multidemensional array
      * that represents rows.
      */
     public buildRows(size, data) {
          return data.reduce(
               (segments, _, index) =>
                    index % size === 0 ? [...segments, data.slice(index, index + size)] : segments,
               [],
          );
     }
}

export default new Builder();
